import React from 'react';
import styled from 'styled-components';

interface TaskCurrentProcessingProps {
    message: string;
    icon?: React.ReactNode;
    className?: string;
}

const CurrentProcessing = styled.div`
    margin-top: 12px;
    padding: 12px 16px;
    background: #e3f2fd;
    border-radius: 6px;
    font-size: 14px;
    color: #1976d2;
    display: flex;
    align-items: center;
    gap: 8px;
    border-left: 4px solid #2196f3;

    .icon {
        font-size: 16px;
    }
`;

const ProcessingIndicator = styled.span`
    display: inline-block;
    padding: 2px 8px;
    background: #e3f2fd;
    color: #1976d2;
    border-radius: 4px;
    font-size: 11px;
    font-weight: ${(props) => props.theme.font.bold};
`;

/**
 * TaskCurrentProcessing - Atomic component for showing current processing information
 * Displays what the task is currently working on
 */
export const TaskCurrentProcessing: React.FC<TaskCurrentProcessingProps> = ({ message, icon, className }) => {
    return (
        <CurrentProcessing className={className}>
            {icon && <span className='icon'>{icon}</span>}
            <span>{message}</span>
        </CurrentProcessing>
    );
};

export { ProcessingIndicator };
export default TaskCurrentProcessing;
